import { Link } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';
import { SingleDotIcon } from '../SvgIcons/SingleDotIcon';
import { clearLocalStorageFilters } from '@/utils/clear-local-storage-filters.utils';
import { KTDrawer } from '@/metronic/core';

type SubItemProps = {
  title: string | React.ReactNode;
  active?: boolean;
  to?: string;
  openInNewTab?: boolean;
};

const SubItem = ({ title, active, to, openInNewTab }: SubItemProps) => {
  const handleClick = () => {
    clearLocalStorageFilters();
    KTDrawer.hide();
  };

  return (
    <Link
      className={twMerge('menu-item', active && 'active')}
      to={to}
      target={openInNewTab ? '_blank' : undefined}
      onClick={handleClick}
    >
      <div
        className="menu-link gap-[14px] pl-[10px] pr-[10px] py-[8px] border-transparent items-center grow menu-item-active:bg-secondary-active menu-item-active:border-secondary-active menu-item-active:rounded-lg hover:bg-secondary-active hover:rounded-lg dark-mode:menu-item-active:bg-transparent dark-mode:menu-item-active:border-gray-500 dark-mode:hover:bg-transparent dark-mode:hover:border-transparent"
        tabIndex={0}
      >
        <div className="flex justify-center items-center">
          <SingleDotIcon className="w-[5px] h-[5px] [&>circle]:fill-transparent menu-item-active:[&>circle]:fill-purple-5433FF dark-mode:menu-item-active:[&>circle]:fill-primary" />
        </div>
        <span className="menu-title pl-5 text-sm font-light text-black-252E49 select-none [-webkit-touch-callout:none] [-webkit-user-select:none] menu-item-active:text-purple-5433FF menu-item-active:font-[500] menu-link-hover:text-purple-5433FF dark-mode:text-gray-800 dark-mode:menu-link-hover:text-gray-900 dark-mode:menu-item-active:text-primary">
          {title}
        </span>
      </div>
    </Link>
  );
};

export default SubItem;
